import React from 'react'
import { BOOSTER_TYPE, PARENT_ROUTES, ROUTES } from '../utils/constants/enum'

const Home = React.lazy(() => import('./pages/home'))
const About = React.lazy(() => import('./pages/about'))
const AboutSkinConcerns = React.lazy(
    () => import('./pages/about-skin-concerns')
)
const Rewards = React.lazy(() => import('./pages/rewards'))
const PostDetails = React.lazy(() => import('./pages/post-details'))
const TalkwithSale = React.lazy(() => import('./pages/talk-with-sale'))
const Training = React.lazy(() => import('./pages/training'))
const Store = React.lazy(() => import('./pages/store'))
const Device = React.lazy(() => import('./pages/device'))
const TreatmentType = React.lazy(() => import('./pages/treatment-type'))
const Claims = React.lazy(() => import('./pages/claims'))
const Careers = React.lazy(() => import('./pages/careers'))
const FindHydrafacialist = React.lazy(
    () => import('./pages/find-hydrafacialist')
)
const Treatment = React.lazy(() => import('./pages/treatment'))
const TreatmentTypeDetails = React.lazy(
    () => import('./pages/treatment-type-details')
)
const ProviderHome = React.lazy(() => import('./pages/provider-home'))
const HowItWorks = React.lazy(() => import('./pages/how-it-works'))
const Boosters = React.lazy(() => import('./pages/boosters'))
const FreshAccess = React.lazy(() => import('./pages/fresh-access'))
const Search = React.lazy(() => import('./pages/search'))
const Hkx = React.lazy(() => import('./pages/hkx'))
const Hfx = React.lazy(() => import('./pages/hfx'))
const Patents = React.lazy(() => import('./pages/patents/Index'))
const JloProviderHome = React.lazy(() => import('./pages/jlo-provider-home'))
const Ifu = React.lazy(() => import('./pages/ifu'))
const JloClientHome = React.lazy(() => import('./pages/jlo-client-home'))
const Terms = React.lazy(() => import('./pages/terms'))
const Supplier = React.lazy(() => import('./pages/supplier'))
const Events = React.lazy(() => import('./pages/events'))
const Keravive = React.lazy(() => import('./pages/keravive'))
const Hfxclusive = React.lazy(() => import('./pages/hfxclusive'))
const ExploreHydrafacial = React.lazy(
    () => import('./pages/explore-hydrafacial')
)
const hydralockHaBooster = React.lazy(
    () => import('./pages/hydralock-ha-booster')
)
const TalkwithSaleSuccess = React.lazy(
    () => import('./pages/talk-with-sale-success')
)
const GlowTogether = React.lazy(() => import('./pages/glow-together'))
const Dashboard = React.lazy(() => import('./pages/dashboard'))

// SignIn page
const SignIn = React.lazy(() => import('./pages/signin'))
const SignUp = React.lazy(() => import('./pages/signup/Index'))
const SelectAccount = React.lazy(() => import('./pages/signup/select-account'))
const AccountSettings = React.lazy(
    () => import('../router/pages/dashboard/account-settings')
)
const RewardsPage = React.lazy(() => import('./pages/dashboard/rewards'))

const SyndeoReports = React.lazy(
    () => import('../router/pages/dashboard/syndeo-reports')
)
const SyndeoBooster = React.lazy(
    () => import('../router/pages/dashboard/syndeo-reports/boosters')
)
const ClientRewards = React.lazy(
    () => import('../router/pages/dashboard/client-rewards')
)

const UserAssociations = React.lazy(
    () => import('../router/pages/dashboard/user-associations')
)
const StoreTab = React.lazy(() => import('../router/pages/dashboard/store'))
const TheDrop = React.lazy(() => import('../router/pages/dashboard/the-drop'))
const TreatmentDetail = React.lazy(
    () => import('../router/pages/dashboard/treatment/detail')
)
const TreatmentList = React.lazy(
    () => import('../router/pages/dashboard/treatment/list')
)
const AccountDelete = React.lazy(
    () => import('../router/pages/dashboard/account-delete')
)

const EmailSubmission = React.lazy(() => import('./pages/email-submission'))
const CustomProvider = React.lazy(() => import('./pages/customer-provider'))

const ProviderTestimonial = React.lazy(
    () => import('./pages/provider-testimonial')
)

const KeraviveB2C = React.lazy(() => import('./pages/keravive-b2c'))

const KeraviveB2B = React.lazy(() => import('./pages/keravive-B2B'))

const Schools = React.lazy(() => import('./pages/schools'))

const LoyaltyLandingPage = React.lazy(() => import('./pages/loyalty-landing'))

const DeviceUpdateConsent = React.lazy(
    () => import('./pages/device-update-consent')
)

const HydrafacialInTheNews = React.lazy(
    () => import('./pages/hydrafacial-in-the-news')
)

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
    { path: '/', name: 'Home', component: Home },
    { path: ROUTES.CONSENT, name: 'Consent', component: DeviceUpdateConsent },
    { path: ROUTES.REWARDS, name: 'Rewards', component: Rewards },
    {
        path: ROUTES.SKIN_CONDITIONS,
        name: 'Learn about skin concerns',
        component: AboutSkinConcerns,
    },
    {
        path: ROUTES.HYDRALOCK_HA_BOOSTER,
        name: 'Hydralock HA Booster',
        component: hydralockHaBooster,
    },
    {
        path: ROUTES.STORE,
        name: 'Store',
        component: Store,
    },
    { path: '/post/:url/', name: 'Post Details', component: PostDetails },
    {
        path: ROUTES.ABOUT_US,
        name: 'About',
        component: About,
    },
    {
        path: ROUTES.TALK_WITH_SALES,
        name: 'Talkwithsale',
        component: TalkwithSale,
    },
    {
        path: `${ROUTES.TALK_WITH_SALES}:source/`,
        name: 'Talkwithsale',
        component: TalkwithSale,
    },
    {
        path: `${ROUTES.TALK_WITH_SALES}:source/success`,
        name: 'Talkwithsale',
        component: TalkwithSaleSuccess,
    },
    {
        path: ROUTES.DEVICES,
        name: 'Device',
        component: Device,
    },

    {
        path: ROUTES.TRAINING,
        name: 'Training',
        component: Training,
    },
    {
        path: ROUTES.TREATMENT_TYPES,
        name: 'TreatmentTypes',
        component: TreatmentType,
    },
    {
        path: ROUTES.CLAIMS,
        name: 'Claims',
        component: Claims,
    },
    {
        path: ROUTES.CAREERS,
        name: 'Careers',
        component: Careers,
    },
    {
        path: ROUTES.TREATMENTS,
        name: 'Treatments',
        component: Treatment,
    },
    {
        path: `${ROUTES.TREATMENT_TYPE_DETAIL}/:type/`,
        name: 'TreatmentTypeDetails',
        component: TreatmentTypeDetails,
    },
    {
        path: `${ROUTES.TREATMENT_TYPE_DETAIL}/:type/:category/`,
        name: 'TreatmentTypeDetails',
        component: TreatmentTypeDetails,
    },
    {
        path: ROUTES.FIND_HYDRAFACIALIST,
        name: 'Find a Hydrafacialist',
        component: FindHydrafacialist,
    },
    {
        path: ROUTES.FOR_PROFESSIONAL,
        name: 'For Professional',
        component: ProviderHome,
    },
    {
        path: ROUTES.HOW_IT_WORKS,
        name: 'How it works',
        component: HowItWorks,
    },
    {
        path: `/provider-${BOOSTER_TYPE.SOLUTIONS}/:url`,
        name: 'Booster Solutions',
        component: Boosters,
    },
    {
        path: `/provider-${BOOSTER_TYPE.BRANDS}/:url`,
        name: 'Boosters Brands',
        component: Boosters,
    },
    {
        path: `/provider-${BOOSTER_TYPE.ENHANCEMENTS}/:url`,
        name: 'Boosters Enhancements',
        component: Boosters,
    },
    {
        path: `/provider-${BOOSTER_TYPE.CARE}/:url`,
        name: 'Boosters Care',
        component: Boosters,
    },
    {
        path: `/${BOOSTER_TYPE.SOLUTIONS}/:url`,
        name: 'Booster Solutions',
        component: Boosters,
    },
    {
        path: `/${BOOSTER_TYPE.BRANDS}/:url`,
        name: 'Boosters Brands',
        component: Boosters,
    },
    {
        path: `/${BOOSTER_TYPE.ENHANCEMENTS}/:url`,
        name: 'Boosters Enhancements',
        component: Boosters,
    },
    {
        path: `/${BOOSTER_TYPE.CARE}/:url`,
        name: 'Boosters Care',
        component: Boosters,
    },
    {
        path: ROUTES.FRESH_ACCESS,
        name: 'fresh access',
        component: FreshAccess,
    },
    {
        path: ROUTES.SEARCH,
        name: 'Search',
        component: Search,
    },
    {
        path: ROUTES.HKX,
        name: 'HKX',
        component: Hkx,
    },
    {
        path: ROUTES.HFX,
        name: 'HFX',
        component: Hfx,
    },
    {
        path: ROUTES.IFU,
        name: 'IFU',
        component: Ifu,
    },
    {
        path: ROUTES.PATENTS,
        name: 'Patents',
        component: Patents,
    },
    {
        path: ROUTES.JLOPROVIDERHOME,
        name: 'Jlo provider home ',
        component: JloProviderHome,
    },
    {
        path: ROUTES.JLO_CLIENT_HOME,
        name: 'Jlo Client Home',
        component: JloClientHome,
    },
    {
        path: ROUTES.TERMS,
        name: 'Terms',
        component: Terms,
    },
    {
        path: ROUTES.SUPPLIER,
        name: 'Supplier',
        component: Supplier,
    },
    {
        path: ROUTES.EVENTS,
        name: 'Events',
        component: Events,
    },
    {
        path: ROUTES.KERAVIVE,
        name: 'Keravive',
        component: Keravive,
    },
    {
        path: ROUTES.HFXCLUSIVE,
        name: 'HFXxlusive',
        component: Hfxclusive,
    },
    {
        path: ROUTES.HYDRAFACIAL_IN_THE_NEWS,
        name: 'Hydrafacial in the news',
        component: HydrafacialInTheNews,
    },
    {
        path: ROUTES.ACCOUNTS_SIGNIN,
        name: 'SignIn',
        component: SignIn,
        childOf: PARENT_ROUTES.ONBOARDING,
    },
    {
        path: ROUTES.GLOWTOGETHER,
        name: 'Glow Together',
        component: GlowTogether,
    },
    {
        path: ROUTES.EXPLORE_HYDRAFACIAL,
        name: 'Explore Hydrafacial',
        component: ExploreHydrafacial,
    },
    {
        path: ROUTES.DASHBOARD,
        name: 'dashboard',
        component: Dashboard,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.ACCOUNTS_SIGNUP,
        name: 'SignUp',
        component: SignUp,
        childOf: PARENT_ROUTES.ONBOARDING,
    },
    {
        path: ROUTES.ACCOUNTS_SELECT_ACCOUNT,
        name: 'SelectAccount',
        component: SelectAccount,
        childOf: PARENT_ROUTES.ONBOARDING,
    },
    {
        path: ROUTES.ACCOUNT_SETTINGS,
        name: 'account setting',
        component: AccountSettings,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.SYNDEO_REPORTS,
        name: 'syndeo reports',
        component: SyndeoReports,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.SYNDEO_BOOSTER,
        name: 'syndeo booster',
        component: SyndeoBooster,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.CLIENT_REWARDS,
        name: 'client rewards',
        component: ClientRewards,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.HYDRAFACIALISTS,
        name: 'hydrafacialists',
        component: UserAssociations,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.STORE_TAB,
        name: 'store',
        component: StoreTab,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.THE_DROP,
        name: 'the-drop',
        component: TheDrop,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.SIGNUPSTEPS,
        name: 'SignUp',
        component: SignUp,
        childOf: PARENT_ROUTES.ONBOARDING,
    },
    {
        path: ROUTES.PROVIDER,
        name: 'Provider',
        component: UserAssociations,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.TREATMENT_HISTORY,
        name: 'Client',
        component: TreatmentDetail,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.TREATMENT,
        name: 'Client',
        component: TreatmentList,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.REWARDS_PAGE,
        name: 'Client',
        component: RewardsPage,
        childOf: PARENT_ROUTES.DASHBOARD,
    },

    {
        path: ROUTES.ACCOUNT_DELETE,
        name: 'account-delete',
        component: AccountDelete,
        childOf: PARENT_ROUTES.DASHBOARD,
    },
    {
        path: ROUTES.EMAIL_SUBMISSION,
        name: 'Email Submission',
        component: EmailSubmission,
    },
    {
        path: ROUTES.CUSTOMER_PROVIDER,
        name: 'customer provider',
        component: CustomProvider,
    },
    {
        path: ROUTES.PROFESSIONAL_TESTIMONIALS,
        name: 'provider testimonial',
        component: ProviderTestimonial,
    },
    {
        path: `${ROUTES.PROFESSIONAL_TESTIMONIALS_SUCCESS}`,
        name: 'provider testimonial',
        component: ProviderTestimonial,
    },
    {
        path: `${ROUTES.KERAVIVE_B2C}`,
        name: 'keravive b2c',
        component: KeraviveB2C,
    },
    {
        path: `${ROUTES.KERAVIVE_B2B}`,
        name: 'kervive B2B',
        component: KeraviveB2B,
    },
    {
        path: `${ROUTES.SCHOOL}`,
        name: 'schools',
        component: Schools,
    },
    // {
    //     path: `${ROUTES.LOYALTY_LANDING}`,
    //     name: 'Loyalty',
    //     component: LoyaltyLandingPage,
    // },
]

// CLIENT_TREATMENT
export default routes
